export const AGENDA_HAS_ERRED = 'AGENDA_HAS_ERRED';
export const AGENDA_IS_LOADING = 'AGENDA_IS_LOADING';
export const AGENDA_FETCHED_OK = 'AGENDA_FETCHED_OK';



// WEBPACK FOOTER //
// ./src/data/constants/agenda.js